import { Branch } from '../models/branch.model';
import { Role } from '../models/role.model';

export interface UsrInfo {
    email: string;
    userName: string;
    city: string;
    office: string;
    status: string;
    updated?: Date;
    updatedBy?: string;
    branches: Branch[];
    roles: Role[];
}

export class UsrInfoC implements UsrInfo {
  email: string = null;
  userName: string = null;
  city: string = null;
  office: string = null;
  status: string = null;
  updated?: Date = null;
  updatedBy?: string = null;
  branches: Branch[] = [];
  roles: Role[] = [];
}
